import { BoxConsumableStatus } from "@modules/boxConsumable/entities/boxConsumableType"
import { BoxPurchasesDto, BoxPurchasesDtoSchema } from "@modules/boxPurchases/gateway/boxPurchasesApiDto"
import { BoxPurchasesApiGateway } from "@modules/boxPurchases/gateway/boxPurchasesApiGateway"
import { BoxSubscriptionStatus } from "@modules/boxSubscription/gateway/boxSubscriptionApiDto"
import { ApiClient } from "@modules/core/api/client/apiClient"

export class BoxPurchasesApi implements BoxPurchasesApiGateway {
  private baseUrl = "/box/members"
  constructor(private api: ApiClient) {}

  async creditPurchase(memberId: string, purchaseId: string, newCredits: number): Promise<void> {
    await this.api.post(`${this.baseUrl}/${memberId}/purchases/${purchaseId}/credit`, {
      newCredits,
    })
  }

  async deletePurchase(memberId: string, purchaseId: string): Promise<void> {
    await this.api.delete(`${this.baseUrl}/${memberId}/purchases/${purchaseId}`)
  }

  async getFilteredPurchases(
    memberId: string,
    fetchArchived?: boolean,
    consumableStatusFilter?: BoxConsumableStatus[] | null,
    subscriptionStatusFilter?: BoxSubscriptionStatus[] | null,
  ): Promise<BoxPurchasesDto> {
    const resultDto = await this.api.get<BoxPurchasesDto>(`${this.baseUrl}/${memberId}/filtered-purchases`, {
      params: {
        fetchArchived,
        consumableStatusFilter,
        subscriptionStatusFilter,
      },
      paramsSerializer: {
        indexes: null,
      },
    })

    return BoxPurchasesDtoSchema.parse(resultDto.data)
  }
}
